import React from 'react';

import navigateToURL from 'lib/navigateToURL';
import {getTestDefinitionURL} from 'sample-tests/network/TestDefinitionDAO';
import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import SmartChip from 'ui-library/chips/SmartChip';
import useSmartChipQuery, {SmartChipType} from 'ui-library/chips/useSmartChipQuery';
import {apiIdToIconName} from 'util/APIUtil';
import {BasicEvent} from 'util/Types';

import {TestDefinitionChipPopoverContent} from './TestDefinitionChipPopoverContent';

export interface TestDefinitionChipProps extends SharedSmartChipProps<SmartChipType.TEST_DEFINITION> {}

export default function TestDefinitionChip(props: TestDefinitionChipProps): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: testDefinition,
    handleClickLink,
    isInaccessible,
  } = useSmartChipQuery<SmartChipType.TEST_DEFINITION>({
    id,
    onClick,
  });

  const handleClickLinkEnhanced = (e: BasicEvent): void => {
    if (testDefinition) {
      e.stopPropagation();
      if (props.onClick != null) {
        handleClickLink(e);
      } else {
        navigateToURL(getTestDefinitionURL(testDefinition.id));
      }
    }
  };

  const testDefinitionId = testDefinition?.id;

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={testDefinitionId ? apiIdToIconName(testDefinitionId) : null}
      isInaccessible={isInaccessible}
      item={testDefinition}
      onClick={handleClickLinkEnhanced}
      url={testDefinitionId ? getTestDefinitionURL(testDefinitionId) : null}
      popoverContentOverride={
        <TestDefinitionChipPopoverContent isInaccessible={isInaccessible} testDefinition={testDefinition} />
      }
    />
  );
}
